import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Map as LeafletMap, Marker, Popup, TileLayer } from "react-leaflet";
import moment from "moment";

import SearchBox from "../components/SearchBox";
import LoadingCard from "../components/LoadingCard";
import { useUser } from "../firebase";
import { stateOptions, countryOptions, getCountryStateLabel } from "../schema";

const Landing = () => {
  const { summary, summaryLoading } = useUser();
  const [positions, setPositions] = useState([]);
  useEffect(
    () => {
      const newPos = [];
      Object.entries(summary.state).forEach(([st, count]) => {
        const [country, state] = st.split(";");
        const pos = {};
        if (state === "-") {
          const c = countryOptions.find(option => option.value === country);
          pos.lat = c.lat;
          pos.lng = c.lng;
        } else {
          const s = stateOptions[country].find(
            option => option.value === state
          );
          pos.lat = s.lat;
          pos.lng = s.lng;
        }
        const label = getCountryStateLabel(country, state);
        pos.country = label.country;
        pos.state = label.state;
        pos.key = st;
        pos.countryKey = country;
        pos.stateKey = state;
        pos.count = count;
        newPos.push(pos);
      });
      setPositions(newPos);
    },
    [summary]
  );
  return (
    <Container>
      <Row className="py-4">
        <Col lg={4} className="mb-3">
          <SearchBox />
        </Col>
        <Col lg={8} className="mb-3">
          {summaryLoading ? (
            <LoadingCard className="map-height" />
          ) : (
            <div>
              <LeafletMap center={[0, 0]} zoom={2}>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
                />
                {positions.map(pos => (
                  <Marker key={pos.key} position={[pos.lat, pos.lng]}>
                    <Popup>
                      <div>
                        {`${(pos.stateKey !== "-") ? (pos.state + ", ") : ""}${
                          pos.country
                        }: ${pos.count}`}
                      </div>
                      <Link
                        to={`/search?country=${pos.countryKey}&state=${
                          pos.stateKey
                        }`}
                      >
                        See more
                      </Link>
                    </Popup>
                  </Marker>
                ))}
              </LeafletMap>
              <span className="lastUpdated">
                <i>Last updated: {moment(summary.lastUpdated).fromNow()}</i>
              </span>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Landing;
